var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "live" } },
    [
      _c(
        "div",
        { class: _vm.getMediaClasses(), attrs: { id: "media" } },
        [
          _c("b-container", [
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm.asset.type === 5 ? _c("Meeting") : _c("Player"),
                _vm.asset.slideinstances.length ? _c("BigSlide") : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.asset.type === 5 || _vm.asset.slideinstances.length
        ? _c("Controllers")
        : _vm._e(),
      _vm.asset.slideinstances.length
        ? _c("Slides", { attrs: { live: true } })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "py-5 py-md-8", attrs: { id: "info" } },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      class:
                        _vm.asset.agenda && _vm.asset.agenda.length
                          ? "pb-7"
                          : null,
                      attrs: {
                        cols: "12",
                        md:
                          _vm.asset.agenda && _vm.asset.agenda.length
                            ? "8"
                            : "12",
                      },
                    },
                    [
                      _c("h2", {
                        staticClass: "title-color",
                        domProps: {
                          innerHTML: _vm._s(_vm.makeBr(_vm.asset.title)),
                        },
                      }),
                      _vm.asset.description
                        ? _c("p", {
                            staticClass: "lead m-0 pt-3",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.makeBr(_vm.asset.description)
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm.asset.tags && _vm.asset.tags.length
                        ? _c(
                            "div",
                            { staticClass: "pt-3", attrs: { id: "tags" } },
                            _vm._l(_vm.asset.tags, function (tag, key) {
                              return _c(
                                "b-badge",
                                { key: key, staticClass: "mr-1" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(tag.name ? tag.name : tag) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm.asset.agenda && _vm.asset.agenda.length
                    ? _c(
                        "b-col",
                        { attrs: { cols: "12", md: "4" } },
                        [_c("Agenda")],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.asset.breakouts && _vm.asset.breakouts.length
        ? _c("Breakouts")
        : _vm._e(),
      (_vm.asset.asset_qa &&
        _vm.asset.asset_qa.enabled &&
        _vm.asset.asset_qa.sidebar) ||
      _vm.asset.chat_url ||
      _vm.asset.poll_url
        ? _c("Sidebar")
        : _vm._e(),
      _vm.asset.asset_qa &&
      _vm.asset.asset_qa.enabled &&
      !_vm.asset.asset_qa.sidebar
        ? _c("Ask", { attrs: { live: true } })
        : _vm._e(),
      _vm.asset.slideinstances.length && _vm.viewSlide
        ? _c(
            "b-modal",
            {
              attrs: {
                id: "slideModal",
                size: "xl",
                show: "",
                "hide-header": "",
                "hide-footer": "",
                centered: "",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.zoomOutSlide.apply(null, arguments)
                },
              },
            },
            [
              _c("b-img", {
                attrs: { src: _vm.slideUrl(_vm.viewSlide), fluid: "" },
                on: { click: _vm.zoomOutSlide },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }